/** Resolve id from a string or populated `{ id }` ref. */
export const getRefId = (value: unknown): string | undefined => {
	if (typeof value === "string" && value.length > 0) return value;
	if (
		value &&
		typeof value === "object" &&
		"id" in value &&
		typeof (value as { id: unknown }).id === "string"
	) {
		return (value as { id: string }).id;
	}
	return undefined;
};
